import { isEmpty } from 'lodash'

export const handleErrors = (message, messages) => {
  const noMessages = isEmpty(messages)

  if (!noMessages) {
    return messages[0].message
  }

  return message
}
